// extracted by mini-css-extract-plugin
export default {"widgetGap":"1rem"};